import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { View, TouchableOpacity } from 'react-native';
import { PALETTE } from '../../../constants';
import styles from './payment-touchable-list-item.styles';
import { TrashCircle, EditCircle } from '@dbk/ui-icons';
import {ICON_STYLE} from '../constant';
import { createContainer } from 'dwomuster/muster/react';

class PaymentTouchableListItem extends PureComponent {
  static propTypes = {
    children: PropTypes.node
  };
  
  render() {
    const {i18n: { messages}, children, editItem, deleteItem, item ,editVisible, addBeneficiaryDisabled} = this.props;
    return (
      <div className="pointer dropDownFilterOptions">
        <View style={styles.root}>
          <View style={styles.content}>{children}</View>
          <View style={styles.arrowWrapper}>
              <View style={styles.arrow}>
              { editVisible && 
                <TouchableOpacity tabIndex="0" style={addBeneficiaryDisabled?[styles.disabled,styles.editContainer]:styles.editContainer} onPress={!addBeneficiaryDisabled?(event) => editItem(event, item):(event)=>{event.stopPropagation()}} onClick={!addBeneficiaryDisabled?(event) => editItem(event, item):(event)=>{event.stopPropagation()}} aria-label={messages['app.payment.editButton']} accessibilityRole="button">
                  <EditCircle width={ICON_STYLE.width} height={ICON_STYLE.height} color={PALETTE.secondaryActive} />                                                                                                                                                                                                                     
                </TouchableOpacity>
              }
                  <TouchableOpacity tabIndex="0" style={addBeneficiaryDisabled && styles.disabled} onPress={!addBeneficiaryDisabled?(event) => deleteItem(event, this.props.item):(event)=>{event.stopPropagation()}} onClick={!addBeneficiaryDisabled?(event) => deleteItem(event, this.props.item):(event)=>{event.stopPropagation()}} aria-label={messages['app.payment.deleteButton']} accessibilityRole="button">
                    <TrashCircle width={ICON_STYLE.width} height={ICON_STYLE.height} color={PALETTE.secondaryActive} />
                  </TouchableOpacity>
                </View>
          </View>
        </View>
      </div>
    );
  }
}

PaymentTouchableListItem.defaultProps = {
  editVisible: true
};

export default createContainer({
  $queries: {
    i18n: {
      messages: true,
    },
  },
})(PaymentTouchableListItem);



